import { render, staticRenderFns } from "./ThresholdBox.vue?vue&type=template&id=034fe63e&scoped=true"
import script from "./ThresholdBox.vue?vue&type=script&lang=js"
export * from "./ThresholdBox.vue?vue&type=script&lang=js"
import style0 from "./ThresholdBox.vue?vue&type=style&index=0&id=034fe63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034fe63e",
  null
  
)

export default component.exports